export default class VesselMetricsData {
  constructor(trim, meanDraft, fouling) {
    this.trim = trim,
    this.meanDraft = meanDraft;
    this.fouling = fouling;
  }
}
